<template>
  <div>
    <h3
      class="has-text-centered"
      v-text="$wording.resetpw.success_1"
    />
    <p v-html="$sprintf($wording.resetpw.success_2, email)" />
    <!-- <p class="has-text-centered">
      <router-link :to="{ name: 'login' }">
        Log in to your account
      </router-link>
    </p> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
    };
  },
  beforeMount() {
    this.email = this.$sCache.get('email-reset') ? `to <strong>${this.$sCache.get('email-reset')}</strong>` : '';
    this.$sCache.clear('email-reset');
  },
};
</script>